import { useNavigate, useLocation } from 'react-router-dom';
import { SettingsLayout } from '@/components/Pages/SettingsLayout';
import { SettingsIntegrations } from './settings/settings-integrations';

export function SettingsIntegrationsPage() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <SettingsLayout currentPath={location.pathname} onNavigate={navigate}>
      <div className="h-full overflow-y-auto">
        <SettingsIntegrations />
      </div>
    </SettingsLayout>
  );
}

export default SettingsIntegrationsPage;
